export const REHYDRATE = 'persist/REHYDRATE';
export const STORAGE_KEY_V5 = 'neo4j.bloom.v5';
export const STORAGE_KEY_V6 = 'neo4j.bloom.v6';
